import _isFunction from "lodash/isFunction";
import { useMemo } from "react";
export default function useGetter(state) {
    return useMemo(() => {
        if (_isFunction(state)) {
            return state;
        }
        return () => state;
    }, [state]);
}
